/**
 * Handles adding an item to cart without refresh and has the cart dialog pop up
 *
 * Usage:
 *
 *  These data attributes should be used with the inputs that we submit the form with.
 *  data-sw-add-to-cart-form
 *
 */

var $ = require('js/sw-jquery/sw-jquery');
var sw = require('js/lib/sw');

$(function(){
  $('body').on('submit' ,'[data-sw-add-to-cart-form]' ,function(e){

    var $el = $(e.currentTarget);
    //params
    var href = $el.attr('action');

    var formData = $el.swFormValues();

    try{
      $.swAjax({
        timeout: $.swAjax.SW_TIMEOUT_TIME,
        url: href,
        data: formData,
        type: 'post',
        retryTimeout: function retryTimeout(jqXHR, textStatus, errorThrown, swInfo) {
          $.swAjax.triggerDefaultRetryNotey(swInfo.retryEventID);
        },
        error: function error(jqXHR, textStatus) {
          if (textStatus !== $.swAjax.ERROR_TYPES.TIMEOUT) {
            $.swAjax.triggerDefaultFailNotey();
          }
        },
        success: function (html) {
          if (html) {
            var data = $el.swFormValues();
            sw.trigger('cart-add-product', html, data.itemId, {quantity: data.quantity});
          }
        }
      });
      e.preventDefault();
    }
    catch(err){
      return true;
    }

  });
});
